import {
  ACCORDION_LIST_CONTENT_CLASS,
  normalizeAccordionListHtml,
} from "@/lib/accordion-content";
import { cn } from "@/lib/utils";

interface AccordionHtmlContentProps {
  html: string;
  richText?: boolean;
  className?: string;
}

export function AccordionHtmlContent({
  html,
  richText = false,
  className,
}: AccordionHtmlContentProps) {
  const normalizedHtml = normalizeAccordionListHtml(html);
  if (!normalizedHtml) return null;

  return (
    <div
      dangerouslySetInnerHTML={{ __html: normalizedHtml }}
      className={cn(
        ACCORDION_LIST_CONTENT_CLASS,
        richText && "catalogue-accordion-rich-text",
        className,
      )}
    />
  );
}
